/**
 * React Query hook for the active workspace's tags. One cache entry feeds the projects list,
 * the project page and the tags page, so a tag changed on one is changed on all.
 */

import { useQuery } from "@tanstack/react-query";
import { getTags, type Tag } from "../services/naraDoor";
import { useWorkspace } from "../contexts/WorkspaceContext";

export function useTags() {
  const { activeWorkspace } = useWorkspace();
  const workspaceId = activeWorkspace?.id;
  const tagsDisabled = (activeWorkspace?.settings?.tags as { access?: string } | undefined)?.access === "none";

  const query = useQuery<Tag[]>({
    queryKey: ["tags", workspaceId],
    queryFn: async () => {
      try {
        return (await getTags(workspaceId!)).tags ?? [];
      } catch (err) {
        console.error("getTags failed", { workspaceId, error: (err as Error).message });
        throw err;
      }
    },
    enabled: !!workspaceId && !tagsDisabled,
  });

  return { ...query, tags: tagsDisabled ? [] : (query.data ?? []) };
}
